export const sidebarData = [
    { path: "/", icon: "home", name: "Feed" },
    { path: "/explore", icon: "explore", name: "Explore" },
    { path: "/bookmark", icon: "bookmark_border", name: "Bookmarks" },
    { path: "/search", icon: "search", name: "Search" },
    { path: "/profile/:userId", icon: "perm_identity", name: "Profile" },
];
